export function getClipTitleFrame(clip) {
  const frame = clip?.frames?.title;
  return frame?.design_project_id != null ? frame : null;
}

export function getClipFrameDesignProjectIds(clip) {
  return Object.values(clip?.frames || {})
    .filter(frame => frame?.design_project_id != null)
    .map(frame => String(frame.design_project_id));
}

export function getFrameFileName({frameType}) {
  return `${frameType}.${VIDEO_EDITOR_TITLE_FRAME_EXTENSION}`;
}

export function getFrameUploadResponseKey({clipId, frameType, fileName}) {
  return `${clipId}::${frameType}::${fileName}`;
}

export function getFrameExportDedupeKey({clipId, frameType, designProjectId}) {
  return `${clipId}::${frameType}::${designProjectId}`;
}
